import React from "react";

import { formatCurrencyRange, formatNumericCurrency, getEnvironment } from "utils";

import { Col, ModuleIconStatusPanel, Row } from "components";

// If the payout is partial, preVerificationPayout can be used to show what the total payout would have been
export const PayoutInVerification = ({
  modules,
  payout,
  preVerificationPayout,
  payoutAtVerificationStart,
  caption,
  subCaption,
  rejected = false,
  currency,
}) => (
  <div className="payout-card-content">
    <Row>
      <Col lg={20} className="payout-column">
        <span data-testid="payout-overview-card-big-number-span" className={`big-number-text ${rejected ? "rejected" : ""}`}>
          {formatCurrencyRange(payout.min, payout.max, { currency })}
        </span>

        {preVerificationPayout?.min || preVerificationPayout?.max ? (
          <span data-testid="payout-overview-card-rejected-total" className="rejected-total rejected">
            {formatCurrencyRange(preVerificationPayout.min, preVerificationPayout.max, { currency })}
          </span>
        ) : null}

        {payoutAtVerificationStart && getEnvironment().admin ? (
          <span data-testid="payout-overview-card-payout-at-verification-start">
            payout at verification start: {formatNumericCurrency(payoutAtVerificationStart, { currency })}
          </span>
        ) : null}

        <span>{caption}</span>
        {subCaption}
      </Col>

      <Col lg={4} className="icon-status-column">
        {modules?.length > 0 && (
          <div className="icon-status margin-top-0">
            <ModuleIconStatusPanel modules={modules} alignRight />
          </div>
        )}
      </Col>
    </Row>
  </div>
);
